import React, { useEffect, useState } from "react";
import { Bell, BellOff } from "lucide-react";

import {
  getChannelFollowStatus,
  followChannel,
  unfollowChannel,
} from "../../notification/services/notificationService";

import "./ChannelFollowButton.css";

const ChannelFollowButton = ({ username }) => {
  const [isFollowing, setIsFollowing] = useState(false);
  const [isOwner, setIsOwner] = useState(false);
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    let active = true;

    setLoading(true);
    setError("");

    if (!username) {
      setLoading(false);
      return;
    }

    const loadStatus = async () => {
      try {
        const res = await getChannelFollowStatus(username);

        if (!active) return;

        setIsFollowing(Boolean(res.data?.isFollowing));
        setIsOwner(Boolean(res.data?.isOwner));
      } catch (requestError) {
        if (!active) return;

        setError(
          requestError?.response?.data?.message ||
            "Unable to load follow status.",
        );
      } finally {
        if (active) setLoading(false);
      }
    };

    void loadStatus();

    return () => {
      active = false;
    };
  }, [username]);

  const handleToggle = async () => {
    if (!username || loading || saving || isOwner) return;

    try {
      setSaving(true);
      setError("");

      const res = isFollowing
        ? await unfollowChannel(username)
        : await followChannel(username);

      if (res.data?.success) {
        setIsFollowing(Boolean(res.data.isFollowing));
      }
    } catch (requestError) {
      setError(
        requestError?.response?.data?.message ||
          "Unable to update channel follow.",
      );
    } finally {
      setSaving(false);
    }
  };

  if (loading || isOwner || !username) {
    return null;
  }

  return (
    <div className="katch-channel-follow">
      <button
        type="button"
        className={`katch-channel-follow__button ${
          isFollowing ? "katch-channel-follow__button--active" : ""
        }`}
        onClick={handleToggle}
        disabled={saving}
        aria-pressed={isFollowing}
      >
        {isFollowing ? <Bell size={17} /> : <BellOff size={17} />}

        <span>
          {saving
            ? "Updating..."
            : isFollowing
              ? "Following"
              : "Follow Channel"}
        </span>
      </button>

      {error && <small className="katch-channel-follow__error">{error}</small>}
    </div>
  );
};

export default ChannelFollowButton;
